module.exports = __webpack_public_path__ + "media/images/top/img_interview_yoyoshibata-055c1da90b7b192fe8711e7c8b11d513.jpg";